import React from 'react'
import {Button, Card, CardBody, Col, Form, FormGroup, Input, Row} from "reactstrap";
import LocalizedStrings from "react-localization";
import {resource_strings} from "../../translations/resource_translations";
import {common_strings} from "../../translations/common_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import stringHelpers from "../../helpers/StringHelper";
import businessApiService from "../../api/business-api-service";

let resourceStrings = new LocalizedStrings(resource_strings);
let commonStrings = new LocalizedStrings(common_strings);

const propTypes = {};

class CancPolicyView extends React.Component {
    handleChange = this.handleChange.bind(this);

    constructor(props) {
        super(props);
        this.state = {
            pp: props.pp,
            inputsUpdated: true,
        };
    }

    handleChange(event) {

        let newValue = event.target.value;
        let targetId = event.target.id;
        let checkBoxValue = event.target.checked;

        switch (targetId) {
            case "input-hours":
                this.setState(prevState => ({
                    pp: {
                        ...prevState.pp,
                        can_policy: newValue
                    }
                }));
                break;
            case "input-cancellations":
                this.setState(prevState => ({
                    pp: {
                        ...prevState.pp,
                        max_canc: newValue
                    }
                }));
                break;
            case "input-cancellations_days":
                this.setState(prevState => ({
                    pp: {
                        ...prevState.pp,
                        max_canc_days: newValue
                    }
                }));
                break;
            case "input-time-nl-cb":
                this.setState(prevState => ({
                    pp: {
                        ...prevState.pp,
                        can_policy: checkBoxValue === true ? "n" : "0"
                    }
                }));
                break;
            case "input-max-nl-cb":
                this.setState(prevState => ({
                    pp: {
                        ...prevState.pp,
                        max_canc: checkBoxValue === true ? "-1" : "5",
                        max_canc_days: checkBoxValue === true ? "-1" : "30"
                    }
                }));
                break;
            default:
                return
        }
    }

    updateCP(e) {
        e.preventDefault();

        const cp_data = {
          max_canc: this.state.pp.max_canc,
          max_canc_days: this.state.pp.max_canc_days,
          can_policy: this.state.pp.can_policy,
        };

        businessApiService.update(cp_data)
            .then(res => {
                this.props.closeCPView()
            })
            .catch((e) => {
                this.props.handleError(e)
            });
    }

    render() {
        this.localize();

        return (
            <Card className="bg-secondary shadow">
                <CardBody>
                    <Form onSubmit={this.handleSubmit}>
                        {this.state.pp &&
                        <div className="pl-lg-4">
                            <div>
                                <b> {resourceStrings.public_profile.canc_policy_time} </b>
                            </div>

                            <Row className="mt-4">
                                <Col lg="12">
                                    <div className="custom-control custom-control-alternative custom-checkbox mb-3">
                                        <input
                                            className="custom-control-input"
                                            id="input-time-nl-cb"
                                            onChange={this.handleChange}
                                            checked={this.state.pp.can_policy === "n"}
                                            type="checkbox"
                                        />
                                        <label className="custom-control-label" htmlFor="input-time-nl-cb">
                                            {resourceStrings.public_profile.canc_policy_no_limit}
                                        </label>
                                        <div>
                                            <small>{resourceStrings.public_profile.canc_policy_no_limit_expl}</small>
                                        </div>
                                    </div>
                                </Col>
                            </Row>

                            <Row>
                                <Col lg="6">
                                    <FormGroup style={{verticalAlign: 'center='}}>
                                        <label
                                            className="form-control-label"
                                        >
                                            {stringHelpers.capitalize(resourceStrings.public_profile.canc_policy_time_limit)}
                                        </label>
                                        <Input
                                            placeholder={resourceStrings.public_profile.hours}
                                            className="form-control-alternative"
                                            onChange={this.handleChange}
                                            value={this.state.pp.can_policy === "n" ? "" : this.state.pp.can_policy}
                                            id="input-hours"
                                            type="number"
                                            min="0"
                                        />

                                        <div>
                                            <small>{resourceStrings.public_profile.canc_policy_time_limit_expl}</small>
                                        </div>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <hr className="my-4"/>

                            <div>
                                <b> {resourceStrings.public_profile.canc_max_number} </b>
                            </div>

                            <Row className="mt-4">
                                <Col lg="12">
                                    <div className="custom-control custom-control-alternative custom-checkbox mb-3">
                                        <input
                                            className="custom-control-input"
                                            id="input-max-nl-cb"
                                            onChange={this.handleChange}
                                            checked={this.maxUnlimitedMustBeChecked()}
                                            type="checkbox"
                                        />
                                        <label className="custom-control-label" htmlFor="input-max-nl-cb">
                                            {resourceStrings.public_profile.canc_policy_no_limit}
                                        </label>
                                    </div>
                                </Col>
                            </Row>

                            <Row>
                                <Col lg="6">
                                    <FormGroup style={{verticalAlign: 'center='}}>
                                        <label
                                            className="form-control-label"
                                        >
                                            {stringHelpers.capitalize(resourceStrings.public_profile.canc_cancellations)}
                                        </label>
                                        <Input
                                            placeholder={resourceStrings.public_profile.canc_cancellations}
                                            className="form-control-alternative"
                                            onChange={this.handleChange}
                                            value={this.state.pp.max_canc ? this.state.pp.max_canc === "-1" ? "" : this.state.pp.max_canc : ""}
                                            id="input-cancellations"
                                            type="number"
                                            min="0"
                                        />
                                    </FormGroup>
                                </Col>

                                <Col lg="6">
                                    <FormGroup style={{verticalAlign: 'center='}}>
                                        <label
                                            className="form-control-label"
                                        >
                                            {stringHelpers.capitalize(resourceStrings.ticket_days)}
                                        </label>
                                        <Input
                                            placeholder={stringHelpers.capitalize(resourceStrings.ticket_days)}
                                            className="form-control-alternative"
                                            onChange={this.handleChange}
                                            value={this.state.pp.max_canc_days ? this.state.pp.max_canc_days === "-1" ? "" : this.state.pp.max_canc_days : ""}
                                            id="input-cancellations_days"
                                            type="number"
                                            min="0"
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <div className="mb-4">
                                <small>{resourceStrings.public_profile.canc_max_expl}</small>
                            </div>

                        </div>
                        }

                        <Row>
                            <Col lg="12">
                                <Col className="text-right">
                                    <Button
                                        color="warning"
                                        outline="button"
                                        size="lg"
                                        onClick={e => this.props.closeCPView(e)}
                                    >
                                        {commonStrings.close}
                                    </Button>

                                    <Button
                                        color="default"
                                        size="lg"
                                        onClick={e => this.updateCP(e)}
                                    >
                                        {commonStrings.save}
                                    </Button>
                                </Col>
                            </Col>
                        </Row>

                    </Form>
                </CardBody>
            </Card>
        )
    }

    localize() {
        const loc = localeHelpers.currentLocale();
        commonStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    }

    maxUnlimitedMustBeChecked() {
        if (this.state.pp.max_canc === undefined || this.state.pp.max_canc === null) {
            return true
        } else return this.state.pp.max_canc === "-1";
    }
}

CancPolicyView.propTypes = propTypes;

export default CancPolicyView;